import React, { useState, useEffect, useRef } from 'react';
import Header from '../../dashboard/header';
import { Link } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaTools, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaCheck, FaTags, FaSearch, FaQuestion, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Liste_tag = ({ titre }) => {
    useAuth();
    const existingAcces = { acces: [] }; // Ensure this is defined

    const [tags, setTags] = useState([]);
    const [selectedTag, setSelectedTag] = useState(null);
    const [selectedQcm, setSelectedQcm] = useState(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [afficherQcm, setAfficherQcm] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [expandedTagIds, setExpandedTagIds] = useState([]);
    const [tagDescriptionOverflows, setTagDescriptionOverflows] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Nombre d'éléments par page
    const totalItems = tags.length;  // Si 'formationList' contient toutes les formations

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Tag"; // Définit le titre de la page
        }
    }, [user_id]);




    const [qcms, setQcms] = useState([]);
    const handleAdvancedSearchSubmit = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/recherche-avancee/`, {
                method: 'POST',
                body: JSON.stringify({ tag: selectedTag.titre }),
            });
            const data = await response.json();

            if (response.ok) {
                setQcms(data.resultats);
                // handleCloseAdvancedSearchModal();
            } else {
                console.log('Erreur lors de la ...', data);
            }
        } catch (error) {
            console.error("Erreur lors de la recherche avancée :", error);
        }
    };


    const fetchTags = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-tag/');
            const data = await response.json();
            if (response.ok) {
                setTags(data);
            } else {
                showAlert('Erreur lors de la récupération des tags', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {

        fetchTags();
    }, []);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            fetchTags()
        }, 7000);
    };

    const handleRowClick = (tag) => {
        setSelectedTag(tag);
    };


    const handleRowClickQcm = (qcm) => {
        setSelectedQcm(qcm);
    };

    const handleDeleteTag = async () => {
        if (selectedTagIds.length > 0) {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/supprimer-tag/`,
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            tag_ids: selectedTagIds,
                        }),
                    }
                );

                if (response.ok) {
                    fetchTags();
                    showAlert("Tag supprimé avec succès !");
                } else {
                    console.error('Erreur lors de la suppression de tag');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };


    const handleCloseModal = () => setShowModal(false);


    const filteredTags = tags.filter(tag =>
        tag.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        tag.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        tag.nombre_qcm.toString().includes(searchTerm.toLowerCase())
    )

    const sortedTags = [...filteredTags].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleShowDeleteModal = () => {
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };


    const handleAfficherQcmModal = () => {
        handleAdvancedSearchSubmit()
        setAfficherQcm(true);
    };

    const handleFermerQcmModal = () => {
        setAfficherQcm(false);
    };

    // Pagination logic
    const indexOfLastTag = currentPage * itemsPerPage;
    const indexOfFirstTag = indexOfLastTag - itemsPerPage;
    const currentTags = sortedTags.slice(indexOfFirstTag, indexOfLastTag);
    const totalPages = Math.ceil(sortedTags.length / itemsPerPage);

    // Gestion du changement d'éléments par page
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Réinitialiser à la première page
    };

    const handleToggleDescription = (id) => {
        setExpandedDescriptions((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const checkTagDescriptionOverflow = (tags) => {
        tags.forEach((tag) => {
            const element = document.getElementById(`tag-description-${tag.id}`);
            if (element) {
                setTagDescriptionOverflows((prev) => ({
                    ...prev,
                    [tag.id]: element.scrollHeight > element.clientHeight,
                }));
            }
        });
    };

    useEffect(() => {
        checkTagDescriptionOverflow(tags);
    }, [tags]);


    const handleModifier = (tag) => {
        if (tag) {
            navigate('/Modifier-tag/', {
                state: { tag_id: tag.id },
            });
        }
    };




    const [selectedTagIds, setSelectedTagIds] = useState([]);

    const handleCheckboxChange = (id) => {
        setSelectedTagIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };



    const handleModifierQcm = (qcm) => {
        if (qcm) {
            console.log(qcm)
            navigate(`/Modifier-qcm`, {
                state: { qcm_ref: qcm.unicite },
            });
        }
    };

    const handleActiverTag = async () => {
        if (selectedTag) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/activer-desactiver-tag/${selectedTag.id}/`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.ok) {
                    const updatedTag = await response.json();
                    setTags(tags.map((tag) =>
                        tag.id === updatedTag.id ? updatedTag : tag
                    ));
                    setSelectedTag(updatedTag);

                    // Stocker le message de succès dans localStorage
                    showAlert('successMessage', 'Statut du tag changé avec succès !');

                    // Redirection après la mise à jour
                    // window.location.href = `/Liste-tag`;
                } else {
                    const data = await response.json();
                    showAlert('Erreur lors de la mise à jour du statut du tag', data, 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        }
    };
    const [expandedQuestions, setExpandedQuestions] = useState({});
    const [questionOverflows, setQuestionOverflows] = useState({});
    const questionRefs = useRef({}); // Stocker les références de chaque question pour la vérification de débordement

    const toggleExpandQuestion = (qcmId) => {
        setExpandedQuestions((prevState) => ({
            ...prevState,
            [qcmId]: !prevState[qcmId],
        }));
    };

    useEffect(() => {
        const newOverflows = {};
        qcms.forEach((qcm) => {
            const element = questionRefs.current[qcm?.id];
            if (element) {
                // Détecte si la hauteur de défilement dépasse la hauteur de l'élément affiché
                newOverflows[qcm?.id] = element.scrollHeight > element.clientHeight;
            }
        });
        setQuestionOverflows(newOverflows);
    }, [qcms]);


    const [pageCourante, setPageCourante] = useState(1);
    const nombreItemsParPage = 10;

    // Calculer les éléments à afficher pour la page actuelle
    const indexDernierItem = pageCourante * nombreItemsParPage;
    const indexPremierItem = indexDernierItem - nombreItemsParPage;
    const itemsPageCourante = qcms.slice(indexPremierItem, indexDernierItem);

    // Gérer le changement de page
    const changerPage = (numeroPage) => setPageCourante(numeroPage);

    // Calculer le nombre total de pages
    const totalPage = Math.ceil(qcms.length / nombreItemsParPage);

    // Créer des numéros de page
    const numerosDePage = [];
    for (let i = 1; i <= totalPage; i++) {
        numerosDePage.push(i);
    }

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2><FaTags size={25} className='mr-2' />Liste des tags</h2>
                            <small>Administration des Tags.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Tags
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex flex-column justify-content-between flex-md-row mt-3 mb-3 mt-md-0">
                                <h5>Liste des tags</h5>
                                <div className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0" style={{ gap: '10px' }}>
                                    <Link to={`/Ajouter-tag`} className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1">
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">
                                            Ajouter
                                        </span>
                                    </Link>
                                    <button
                                        onClick={() => handleModifier(selectedTag)}
                                        disabled={!selectedTag}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedTag ? 'btn-success' : 'btn-default text-dark'}`}
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">
                                            Modifier
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleAfficherQcmModal}
                                        disabled={!selectedTag}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedTag ? 'btn-success' : 'btn-default text-dark'}`}
                                    >
                                        <FaQuestion />
                                        <span className="d-none d-sm-inline ml-2">
                                            Qcm
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleShowDeleteModal}
                                        className={`btn d-flex align-items-center justify-content-center mr-2 ms-2 mt-1 ${selectedTagIds.length < 1 ? 'btn-default text-dark ' : 'btn-success'}`}
                                        disabled={selectedTagIds.length < 1}
                                    >
                                        <FaTrash />
                                        <span className="d-none d-sm-inline ml-2">
                                            Supprimer
                                        </span>
                                    </button>
                                </div>

                            </div>
                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className='texttagndary text-wrap d-none d-md-table-cell' onClick={() => handleSort('titre')}>
                                                                Titre
                                                                {sortConfig.key === 'titre'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                            </th>
                                                            <th className='texttagndary text-wrap d-none d-md-table-cell' onClick={() => handleSort('description')}>Description {sortConfig.key === 'description'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            {/* <th style={{ width: '20%' }} className='texttagndary text-wrap d-none d-md-table-cell' onClick={() => handleSort('ajoute_par')}>Ajouté par {sortConfig.key === 'ajoute_par'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th> */}
                                                            <th className='text-center text-wrap d-none d-md-table-cell' onClick={() => handleSort('nombre_qcm')}>Nombre qcm {sortConfig.key === 'nombre_qcm'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {currentTags.map((tag) => {
                                                                const isExpanded = expandedDescriptions[tag.id];
                                                                return (
                                                                    <tr
                                                                        key={tag.id}
                                                                        onClick={() => handleRowClick(tag)}
                                                                        className={`bg-white ${selectedTag && selectedTag.id === tag.id ? 'bg-success text-white' : ''}`}
                                                                    >
                                                                        <td>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="i-checks"
                                                                                name="input[]"
                                                                                checked={selectedTagIds.includes(tag.id)}
                                                                                onChange={() => handleCheckboxChange(tag.id)}
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            {tag.titre}
                                                                            <div className='lesInfos'>
                                                                                <small>Description : {tag.description}</small><br />
                                                                                {/* <small>Ajouté par : {tag.ajoute_par}</small><br /> */}
                                                                                <small>Nombre qcm : {tag.nombre_qcm}</small>
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ position: 'relative' }} className="d-none d-md-table-cell">
                                                                            <div
                                                                                id={`tag-description-${tag.id}`}
                                                                                className={`description-text ${expandedDescriptions[tag.id] ? 'expanded' : ''}`}
                                                                                style={{ maxHeight: expandedDescriptions[tag.id] ? 'none' : '3em', overflow: 'hidden', whiteSpace: 'pre-wrap' }}
                                                                            >
                                                                                {tag.description ? (
                                                                                    tag.description
                                                                                ) : (
                                                                                    <em>Non défini</em> // Affichage en italique
                                                                                )}
                                                                            </div>
                                                                            {tag.description && tagDescriptionOverflows[tag.id] && (
                                                                                <button
                                                                                    onClick={() => handleToggleDescription(tag.id)}
                                                                                    style={{ background: 'none', border: 'none', color: 'black', cursor: 'pointer', padding: 0 }}
                                                                                >
                                                                                    {expandedDescriptions[tag.id] ? 'Voir moins' : 'Voir plus...'}
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                        <td className="text-center d-none d-md-table-cell">{tag.nombre_qcm}</td>
                                                                        {/* <td className="d-none d-md-table-cell">{tag.statut}</td> */}
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    ) : (
                                                        <div className="col-md-8" style={{ borderRadius: "15px" }}>
                                                            <span
                                                                className="spinner-border spinner-border-lg text-success"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                        </div>
                                                    )}
                                                </table>
                                            </div>

                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstTag + 1} à ${Math.min(indexOfLastTag, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer le tag <strong>{selectedTag?.nom}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        Annuler
                    </Button>
                    <Button variant="success" onClick={handleDeleteTag}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={afficherQcm} onHide={handleFermerQcmModal} size='lg'>
                <Modal.Header>
                    <Modal.Title>Qcm associés à {selectedTag?.titre}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className='text-right'>
                            <button
                                onClick={() => handleModifierQcm(selectedQcm)}
                                disabled={!selectedQcm}
                                className={`btn mb-2 mb-md-0 ms-md-2 mr-2 ${selectedQcm ? 'btn-success' : 'btn-default text-dark'}`}
                            >
                                <FaEdit /> Modifier
                            </button>
                        </div>

                        <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                            <thead>
                                <tr>
                                    <th>Ref</th>
                                    <th>Question</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsPageCourante.map((qcm) => (
                                    <tr
                                        className={`bg-white ${selectedQcm && selectedQcm.id === qcm.id ? 'bg-success text-white' : ''}`}
                                        onClick={() => handleRowClickQcm(qcm)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td>
                                            {qcm.ref}
                                            <div className='lesInfos'>
                                                <small
                                                    id={`question-${qcm.id}`}
                                                    ref={(el) => (questionRefs.current[qcm.id] = el)}
                                                    className={`question-text ${expandedQuestions[qcm.id] ? 'expanded' : ''}`}
                                                    style={{
                                                        maxHeight: expandedQuestions[qcm.id] ? 'none' : '3em',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'pre-wrap',
                                                    }}
                                                >Question :&nbsp;
                                                    {qcm.question ? (
                                                        <span dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                    ) : (
                                                        <em>Non défini</em>
                                                    )}
                                                </small>
                                                {qcm.question && questionOverflows[qcm.id] && (
                                                    <button
                                                        className='text-success'
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toggleExpandQuestion(qcm.id);
                                                        }}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            color: 'black',
                                                            cursor: 'pointer',
                                                            padding: 0,
                                                        }}
                                                    >
                                                        {expandedQuestions[qcm.id] ? 'Voir moins' : 'Voir plus...'}
                                                    </button>
                                                )}<br />
                                            </div>
                                        </td>
                                        <td className="d-none d-md-table-cell">
                                            <div
                                                id={`question-${qcm.id}`}
                                                ref={(el) => (questionRefs.current[qcm.id] = el)}
                                                className={`question-text ${expandedQuestions[qcm.id] ? 'expanded' : ''}`}
                                                style={{
                                                    maxHeight: expandedQuestions[qcm.id] ? 'none' : '3em',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'pre-wrap',
                                                }}
                                            >
                                                {qcm.question ? (
                                                    <span dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                ) : (
                                                    <em>Non défini</em>
                                                )}
                                            </div>
                                            {qcm.question && questionOverflows[qcm.id] && (
                                                <button
                                                    className='text-success'
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleExpandQuestion(qcm.id);
                                                    }}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        color: 'black',
                                                        cursor: 'pointer',
                                                        padding: 0,
                                                    }}
                                                >
                                                    {expandedQuestions[qcm.id] ? 'Voir moins' : 'Voir plus...'}
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            {/* Affichage de l'information sur la pagination */}
                            <div className="dataTables_info" role="status" aria-live="polite">
                                {qcms.length === 0
                                    ? "Aucun élément à afficher"
                                    : `Élément ${pageCourante === 1 ? 1 : (pageCourante - 1) * nombreItemsParPage + 1} à ${pageCourante * nombreItemsParPage > qcms.length ? qcms.length : pageCourante * nombreItemsParPage} sur ${qcms.length}`}
                            </div>

                            {/* Pagination avec les boutons */}
                            <div>
                                {/* Bouton Précédent */}
                                <button
                                    onClick={() => setPageCourante(pageCourante - 1)}
                                    className={`btn ${pageCourante === 1 ? 'btn-default' : 'btn-light'} mx-1`}
                                    disabled={pageCourante === 1}
                                >
                                    <i className="fa fa-chevron-left"></i> {/* Icône Précédent */}
                                </button>

                                {/* Numéros de page */}
                                {numerosDePage.map((numero) => (
                                    <button
                                        key={numero}
                                        onClick={() => changerPage(numero)}
                                        className={`btn ${pageCourante === numero ? 'btn-default' : 'btn-light'} mx-1`}
                                    >
                                        {numero}
                                    </button>
                                ))}

                                {/* Bouton Suivant */}
                                <button
                                    onClick={() => setPageCourante(pageCourante + 1)}
                                    className={`btn ${pageCourante === totalPage ? 'btn-default' : 'btn-light'} mx-1`}
                                    disabled={pageCourante === totalPage}
                                >
                                    <i className="fa fa-chevron-right"></i> {/* Icône Suivant */}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleFermerQcmModal}>
                        Annuler
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Styles CSS pour les cellules fixes */}
            <style jsx>{`
        width: 300px; /* Ajustez cette valeur selon vos besoins */
        overflow: hidden; /* Évite le débordement de contenu */
        text-overflow: ellipsis; /* Ajoute des "..." pour le contenu tronqué si nécessaire */
        word-wrap: break-word; /* Permet au texte de s'enrouler et de casser les mots longs */
        overflow-wrap: break-word; /* Ajoute cette propriété pour la compatibilité */
        white-space: normal; /* Permet le retour à la ligne */
    `}</style>
        </div>
    );
};

export default Liste_tag;
